import React from 'react';
import { motion } from 'framer-motion';
const pains = ['20 horas semanales en tareas que podrías hacer en 3', 'Parciales donde estudiaste de más para sacar lo mismo de siempre', 'Compañeros con menos dedicación que vos rindiéndote mejor', 'Llegar a 4to año sin saber cómo estudiar eficientemente', 'El mismo ciclo de estrés, el próximo cuatrimestre'];
export function Agitacion() {
  return <section className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-16">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-17">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-10" data-id="element-18">
          ¿Cuántos cuatrimestres más
          <br className="hidden sm:block" data-id="element-19" /> vas a perder así?
        </motion.h2>

        <div className="flex flex-col gap-3.5 mb-10 max-w-[600px] mx-auto" data-id="element-20">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3.5 bg-navy-2 border border-[#1E2D3D] rounded-xl py-4 px-5 text-[15px] leading-[1.5]" data-id="element-21">
              <span className="text-[18px] shrink-0 mt-[1px]" data-id="element-22">❌</span>
              <span className="text-brand-gray" data-id="element-23">{pain}</span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-[clamp(18px,3vw,22px)] font-black text-brand-gold leading-[1.4]" data-id="element-24">
          ¿Y si este fuera el último cuatrimestre que pasás así?
        </motion.p>
      </div>
    </section>;
}